// This file is for state explicitly for kiosk mode

import { atomWithStorage } from 'jotai/utils';

export const kioskDealershipAtom = atomWithStorage<{
  dealershipSlug: string;
} | null>('kioskDealershipAtom', null);
